<template>
  <div class="playlist-wrapper">
    <div
      v-bar="{
        preventParentScroll: true,
        scrollThrottle: 30
      }"
    >
      <div>
        <div
          class="playlist-item"
          v-for="(video, i) in playlist"
          :key="i"
          @click="playVideoEmitter(video)"
          :class="nowPlaying === video.video_id ? 'playing' : ''"
        >
          <div class="play-button" @click="videoUrl = video.video_url">
            <font-awesome-icon
              icon="pause"
              v-if="isSubscribed && nowPlaying === video.video_id"
            />
            <font-awesome-icon
              icon="play"
              v-if="isSubscribed && nowPlaying !== video.video_id"
            />
            <!--locked videos -->
            <font-awesome-icon icon="lock" v-if="!isSubscribed" />
          </div>
          <div class="video-name">{{ video.video_name }}</div>
          <div class="play-time">2:11</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "playlist",
  data() {
    return {
      videoUrl: String,
      index: String,
      videoPlayerHeight: 0
    };
  },
  props: {
    playlist: Array,
    isSubscribed: {
      type: Boolean,
      default: false
    },
    nowPlaying: ''
  },
  created() {
    window.addEventListener("resize", ()=>{
        this.playlistHeight();
    });
  },
  mounted() {
    this.playlistHeight();
  },
  methods: {
    playlistHeight() {
      document.querySelector(".playlist-wrapper").style.height =
        document.getElementById("edforevideoplayer").offsetHeight + "px";
    },
    playVideoEmitter(videoData) {
      if (this.isSubscribed) {
        this.$emit("playVideo", videoData);
      }
    }
  }
};
</script>

<style></style>
